import { AxiosError } from 'axios';
import { ErrorCodes } from '../../../../../../../../constants/api';
import { EMBEDDED_APP_STATES, VALID_IFRAME_URL } from '../../constants';
import { ThemeValues } from '../../../../../../../../components/CiscoUi';

export type DetermineEmbeddedAppStatus = {
  isLoading: boolean;
  isError: boolean;
  isFetching: boolean;
  error?: AxiosError;
  embeddedAppUrl?: string;
};

export const determineEmbeddedAppStatus = ({
  isLoading,
  isError,
  isFetching,
  error,
  embeddedAppUrl,
}: DetermineEmbeddedAppStatus): EmbeddedAppStates => {
  const { UNPROCESSABLE, UNAVAILABLE, LOADING, READY, INVALID_URL } =
    EMBEDDED_APP_STATES;

  if (error?.status === ErrorCodes.Unprocessable) return UNPROCESSABLE;
  if (isError && error?.status !== ErrorCodes.Unprocessable) return UNAVAILABLE;
  if (isLoading || isFetching) return LOADING;
  if (
    embeddedAppUrl !== undefined &&
    !embeddedAppUrl.startsWith(VALID_IFRAME_URL)
  )
    return INVALID_URL;
  return READY;
};

export type DetermineEmbeddedAppIframeUrl = {
  embeddedAppUrl?: string;
  theme: ThemeValues;
};

export const determineEmbeddedAppIframeUrl = ({
  embeddedAppUrl,
  theme,
}: DetermineEmbeddedAppIframeUrl) => `${embeddedAppUrl}&theme=${theme}`;
